export const PLANNER_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:9030';
// API Backend próprio (Avisos e SAC)
export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:9030';
export const DEFAULT_CENTER = { lat: -23.7165, lng: -46.8496 };
